import { Component, OnInit } from '@angular/core';
import { AlertboxComponent } from '../alertbox/alertbox.component';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UmsService } from '../ums.service';
import { ModalpopService } from '../modalpop.service';
import { MatDialogRef } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-grievance-comment',
  templateUrl: './grievance-comment.component.html',
  styleUrls: ['./grievance-comment.component.scss']
})
export class GrievanceCommentComponent implements OnInit {
  dialogRef: MatDialogRef<any>;
  commentForm: FormGroup;
  session: any;
  statusList: any;
  filterstatusList: any;
  submitpayload: any;
  GrievanceData: any;
  grivenceData;
  submitButton = true;
  constructor(public umsService: UmsService,
    private modalPopupService: ModalpopService,
    private fb: FormBuilder,private spinner: NgxSpinnerService,
    private dialogRef2:MatDialogRef<GrievanceCommentComponent>,
  ) { }
  InstuName
  commentFormArray;
  ngOnInit(): void {
    this.submitButton = true;
    const state = history.state;
    this.grivenceData = state.data;
    if (!this.grivenceData) {
      this.grivenceData = JSON.parse(localStorage.getItem('grivenceData') || '{}');
    }
    this.fetchStatus();
    this.getSecretData();
    this.getComplaintData();
    this.loadsettingspage();
    this.commentForm = this.fb.group({
      CommentText: new FormControl ('', [Validators.required]),
    });
  }

  getSecretData() {
    // this.spinner.show();
    let payload = {};
    this.umsService.getSecretData().subscribe((res) => {
      // this.spinner.hide();
      this.InstuName = res.projectPharam['InstituteName']
      this.session = res.projectPharam['SnName']
    })
  }
  fetchStatus() {
    const payload = {};
    payload['CdType'] = 'GS';
    this.umsService.fetchCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.statusList = res.data;
        this.filterstatusList = this.statusList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }
  getComplaintData() {
    this.spinner.show();
    const payload = {};
    this.umsService.getComplaint(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.GrievanceData = res.data[0]['GrievanceID']
      } else {
      }
    },
    //  (ERROR: HttpErrorResponse) => {
    // }
  );
  }
  
  
  Save(){
    if(this.commentForm.invalid){
      this.commentForm.get('CommentText').markAsTouched();
      this.SubmitFormarkAsTouched();
      // this.commentForm.get('Publish').markAsTouched();
      return;
    }
    else{
      this.ADDComment();
    }
  }
  ADDComment() {
    if (this.commentForm.invalid) {
      // this.SubmitFormarkAsTouched();
    } else{
      this.submitpayload = this.commentForm.value;
      let payload = {}
      payload['CommentText'] = this.submitpayload.CommentText
      payload['GrievanceID'] = this.grivenceData.GrievanceID
      payload['Publish'] = this.submitpayload.Publish ? this.submitpayload.Publish : '';
      payload['CommentedByUserID'] = sessionStorage.getItem('loginId')
      // return;
       this.umsService.addComment(payload).subscribe(res => {
        this.submitButton = false;
        if(res.status){
          let data = {}
          data['message'] = res.message
          data['title'] = 'Information'
          data['icon'] = 'fas fa-check'
          this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
          this.dialogRef.afterClosed().subscribe((result) => {
            this.dialogRef2.close();
          });
        }
        else{
        }
      },
    );
    }
 
  }

  onOptionChange(event: Event): void {
    const selectedOption = (event.target as HTMLInputElement).value;
  }
  loadsettingspage() {
    this.spinner.show();
    let payload = {};
    payload['FormPage'] = 'Grievance';
    this.umsService.getStdSetting(payload).subscribe((res) => {
      this.spinner.hide()
      res.data.forEach((element) => {
        if (element.FormVisible) {
          if (element.FormRequired) {
            if (element.FormPattern == '') {
              this.commentForm.addControl(element.FormControlName, new FormControl('', Validators.required));
            } else {
              this.commentForm.addControl(element.FormControlName, new FormControl('', [Validators.required, Validators.pattern(element.FormPattern)]));
            }
          } else {
            if (element.FormPattern == '') {
              this.commentForm.addControl(element.FormControlName, new FormControl(''));
            } else {
              this.commentForm.addControl(element.FormControlName, new FormControl('', [Validators.pattern(element.FormPattern)]));
            }
          }
        }
      });
      this.commentFormArray = res.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  SubmitFormarkAsTouched() {
    this.spinner.show();
    let payload = {};
    payload['FormPage'] = 'Grievance';
    this.umsService.getStdSetting(payload).subscribe((res) => {
      this.spinner.hide();
      res.data.forEach((element) => {
        if (element.FormVisible) {
          if (element.FormRequired) {
            const control = this.commentForm.get(element.FormControlName);
            if (control) {
              control.markAsTouched();
            }
          }
        }
      });
      this.commentFormArray = res.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }
}

